// Converted from js/app-constants.js

// Static List Key Constants
export const StaticListKeyConstants = {
  RACE: 'Race',
  STATE: 'State',
  EDUCATION_LEVEL: 'EducationLevel',
  CONTACT_MODE: 'ContactMode',
  EYE_COLOR: 'EyeColor',
  HAIR_COLOR: 'HairColor',

  getAllKeys: function() {
    return [
      this.RACE,
      this.STATE,
      this.EDUCATION_LEVEL,
      this.CONTACT_MODE,
      this.EYE_COLOR,
      this.HAIR_COLOR
    ];
  },

  MainController: [
    'Race',
    'State',
    'EducationLevel',
    'ContactMode',
    'EyeColor',
    'HairColor'
  ]
};

// Supported Browsers
export const SupportedBrowsers = [
  {
    id: 1,
    name: 'Chrome 42+',
    code: 'chrome',
    link: 'https://www.google.com/intl/en/chrome/browser/desktop/index.html',
    version: '42'
  }
];

// Date Time Constants
export const DateTimeConstants = {
  DATE_FORMAT: 'MM/DD/YYYY',
  DATE_FORMAT1: 'MMMM DD, YYYY',
  DATE_FORMAT2: 'MMMM D',
  DATE_FORMAT3: 'MMMM YYYY',
  TIME_FORMAT: 'h:mma',
  TIME_FORMAT1: 'hh:mma',
  TIME_FORMAT2: 'HHmm',
  TIME_FORMAT3: 'h',
  TIME_FORMAT4: 'm',
  TIME_FORMAT5: 'a',
  TIME_FORMAT24: 'HH:mm',
  TIME_FORMAT242: 'H:mm',
  DB_DATE_FORMAT: 'YYYY-MM-DD',
  DISPLAY_DATE_FORMAT: 'dddd MMMM DD, YYYY',
  DATE_TIME_FORMAT1: 'MM/DD/YYYY h:mma',
  DATE_TIME_FORMAT2: 'MM/DD/YYYY h:m',
  DATE_TIME_FORMAT3: 'MM/DD/YYYY HH:mm:ss',
  DATE_TIME_FORMAT4: 'YYYY-MM-DDTHH:mm:ss',
  DAYS: 'days',
  MONTHS: 'months',
  MINUTES: 'minutes'
};

// Config Constants
export const ConfigConstants = {
  webServiceUrl: '/resource-web-service',
  environment: '',
  cmsPath: '' // Will be loaded from web.properties
};
